import { CreateJobValues } from "src/pages/job/create";
import { AtsJob } from "src/types/merge_ats";
import { containsHTML, htmlToPlainText } from "src/utils/strings";

export class AtsJobClass {
  job: AtsJob;
  constructor(data: AtsJob) {
    this.job = data;
  }

  //   The description might be html or plain text
  descriptionToHtml() {
    const { description } = this.job;
    const isHtml = containsHTML(description);
    if (isHtml) return description;
    // Basic html if it has plain text
    return description.replace(/\n/g, "<br>");
  }

  toOutdefineJobForm(): Partial<CreateJobValues> {
    const { name, description, id, remoteId } = this.job;
    return {
      title: name,
      ATS: {
        ats_id: id,
        ats_remote_id: remoteId
      },
      description: {
        // Basic html for plain text

        html: this.descriptionToHtml(),
        plaintext: htmlToPlainText(description),
        _html: null as any
      }
    };
  }
}
